import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppShell } from "./components/layout/Header";
import { AppRouter } from "./AppRouter";
import { ThemeProvider } from "./components/layout/ThemeProvider";
import { AuthProvider } from "./contexts/AuthContext";

export default function App() {
  const [lang, setLang] = useState("fr");

  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <AppShell lang={lang} setLang={setLang}>
            <AppRouter lang={lang} />
          </AppShell>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
